import script from "./GuestSchoolDetailTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestSchoolDetailTableComponent.vue?vue&type=script&setup=true&lang=js"

import "./GuestSchoolDetailTableComponent.vue?vue&type=style&index=0&id=2a1ab34a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a1ab34a"]])

export default __exports__